import { render, staticRenderFns } from "./memberAvatar.vue?vue&type=template&id=2011a67e&"
import script from "./memberAvatar.vue?vue&type=script&lang=js&"
export * from "./memberAvatar.vue?vue&type=script&lang=js&"
import style0 from "./memberAvatar.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VImg})
